import { filter as adfFilter } from '@atlaskit/adf-utils/traverse';
import type { DocNode } from '@atlaskit/adf-schema';

export const getLinks = (content: DocNode) => {
	return adfFilter(content, (node) => (node.marks || []).some((mark) => mark.type === 'link'));
};
